module.exports = __webpack_public_path__ + "static/media/cubes.9fc4b254.svg";